<template>
    <div class="main-bg pt20">
        <div class="session">
            <!--<ul class="session-tab">
                <li :class="isTypeShow==1?'active':''" @click="isTypeShow=1">消息推送</li>
                <li :class="isTypeShow==2?'active':''" @click="isTypeShow=2">聊天</li>
                <li :class="isTypeShow==3?'active':''" @click="isTypeShow=3">历史记录</li>
            </ul>-->
            <div class="left-panel radius5px" id="left-panel">
                <div class="title">
                    <img class="radius-circle avatar" :src="myInfo.avatar" />
                    <span>{{myInfo.nick}}</span>
                    <!--<span class="exit" title="退出"  @click="imOut()">退出</span>-->
                </div>
                <div class="list-wrap">
                    <div class="list">
                        <!--<div class="m-panel">
                            <div class="panel_item m-sysMsg">
                                <div class="panel_avatar">
                                    <img class="panel_image" src="../assets/images/nim/notice.png" alt="消息中心">
                                </div>
                                <div class="panel_text">
                                    <p class="panel_single-row">消息中心</p>
                                </div>
                                <b class="count j-sysMsgCount hide">0</b>
                            </div>
                        </div>-->
                        <ul class="m-panel">
                            <li class="panel_item"
                                :class="{'active':sessionId==session.id}"
                                v-for="(session,index) in sessionList"
                                :title="session.name"
                                :inline-desc="session.lastMsgShow"
                                :key="session.id"
                                :sessionId="session.id"
                                @contextmenu.prevent="confirmDelSessionId(session.id)"
                                @click="showChat(session)"
                            >
                                <div class="panel_avatar">
                                    <img class="panel_image" :src="session.avatar?session.avatar:require('../assets/images/mrtx.png')" />
                                </div>
                                <div class="panel_text">
                                    <p class="panel_multi-row">
                                        <span class="panel_nick">{{session.name}}</span>
                                        <b class="panel_time">{{session.updateTimeShow}}</b>
                                    </p>
                                    <p class="panel_multi-row">
                                        <span class="panel_lastMsg">{{session.lastMsgShow}}</span>
                                        <b v-show="session.unread > 0" class="panel_count">{{session.unread}}</b>
                                    </p>
                                </div>
                            </li>
                        </ul>
                        <!--<div ref="sessions" id="sessions"></div>-->
                    </div>
                </div>

            </div>
            <div class="right-panel radius5px" id="rightPanel" v-show="isShowChat">
                <chat-index :sessionId="sessionId" v-if="sessionId"></chat-index>
                <!--<div class="chat-box show-netcall-box" id="chatBox" style="">

                    <div class="title" id="chatTitle">
                        <img src="#" width="56" height="56" class="radius-circle img">
                        <span ref="nickName"></span>
                        &lt;!&ndash;<div class="cloudMsg tc radius4px" data-record-id="" id="cloudMsg">
                            <i class="icon icon-team-info"></i>
                            <p>云记录</p>
                        </div>&ndash;&gt;
                    </div>
                    <div class="chat-content box-sizing" id="chatContent">

                    </div>
                    <div class="chat-editor box-sizing">
                        &lt;!&ndash;<div id="emojiTag" class="m-emojiTag"></div>
                        <a class="chat-btn u-emoji" id="showEmoji"></a>
                        <span class="chat-btn msg-type" id="chooseFileBtn">
							<a class="icon icon-file" data-type="file"></a>
						</span>
                        <a class="chat-btn u-netcall-audio-link" id="showNetcallAudioLink">&nbsp;</a>
                        <a class="chat-btn u-netcall-video-link" id="showNetcallVideoLink">&nbsp;</a>
                        &lt;!&ndash; 在netcall_ui.js的fn.whenOpenChatBox中隐藏 &ndash;&gt;
                        <a class="chat-btn u-whiteboard" id="showWhiteboard">&nbsp;</a>&ndash;&gt;

                        <textarea id="messageText" class="chat-btn msg-input box-sizing radius5px p2p" rows="1" autofocus="autofocus" maxlength="500"></textarea>
                        &lt;!&ndash;<span class="chat-context" id="showTeamMsgReceipt" style="display: none;">
							<label for="needTeamMsgReceipt">
							<input id="needTeamMsgReceipt" type="checkbox" name="needTeamMsgReceipt">回执</label>
						</span>&ndash;&gt;
                        <a class="btn-send radius5px" id="sendBtn"  @click="sendMsg()">发送</a>
                        &lt;!&ndash;<form action="#" id="uploadForm">
                            <input multiple="multiple" type="file" name="file" id="uploadFile" class="hide">
                        </form>&ndash;&gt;
                    </div>-->
                </div>
            </div>

    </div>
</template>
<script>
    import util from '../utils'
    import config from '../configs'
    import pageUtil from '../utils/page'
    import ChatIndex from '../components/chat/index.vue'

    //const base = require('@/plugins/NIM/base.js');
    export default {
        data(){
            return {
                /*userInfo:JSON.parse(localStorage.getItem('user'))||null,//登录用户信息
                isTypeShow:1,
                sessions:{},
                currentAcount:'',
                currentSessionId:'',
                messageText:'',
                isBigPanel:'',
                currentFromInfo:null,
                currentIndex:0,
                todayTime:new Date(),
                sessionList:[],
                sessionListStr:'',*/
                sessionId:'',
                isShowChat:false,
                delSessionId: null,
                stopBubble: false,
                noticeIcon: config.noticeIcon,
                myPhoneIcon: config.myPhoneIcon,
                myGroupIcon: config.defaultGroupIcon,
                myAdvancedIcon: config.defaultAdvancedIcon
            }
        },
        components:{ChatIndex},
        mounted(){
            // 提交sdk连接请求
            let that = this;
            that.$store.dispatch('connect');
            setTimeout(function () {
                that.$store.dispatch('updateRefreshState');
                if(that.$route.params.userId){
//                    that.$store.dispatch('getHistoryMsgs',{
//                        scene:'p2p',
//                        to:that.$route.params.userId
//                    });
                    that.setCurrentShow(that.$route.params.userId);
//                    that.$store.dispatch('getServerSessions')
                }
            },1000)

        },
        computed: {
            sysMsgUnread () {
                let temp = this.$store.state.sysMsgUnread
                let sysMsgUnread = temp.addFriend || 0
                sysMsgUnread += temp.team || 0
                let customSysMsgUnread = this.$store.state.customSysMsgUnread
                return sysMsgUnread + customSysMsgUnread
            },
            userInfos () {
                return this.$store.state.userInfos
            },
            myInfo () {
                return this.$store.state.myInfo
            },
            myPhoneId () {
                return `${this.$store.state.userUID}`
            },
            sessionList () {
                let sessionlist = this.$store.state.sessionlist.filter(item => {
                    item.name = ''
                    item.avatar = ''
                    if (item.scene === 'p2p') {
                        let userInfo = null
                        if (item.to !== this.myPhoneId) {
                            userInfo = this.userInfos[item.to]
                        } else {
                            // userInfo = this.myInfo
                            // userInfo.alias = '我的手机'
                            // userInfo.avatar = `${config.myPhoneIcon}`
                            return false
                        }
                        if (userInfo) {
                            item.name = util.getFriendAlias(userInfo)
                            item.avatar = userInfo.avatar
                        }
                    } else if (item.scene === 'team') {
                        let teamInfo = null
                        teamInfo = this.$store.state.teamlist.find(team => {
                            return team.teamId === item.to
                        })
                        if (teamInfo) {
                            item.name = teamInfo.name
                            item.avatar = teamInfo.avatar || (teamInfo.type === 'normal' ? this.myGroupIcon : this.myAdvancedIcon)
                        } else {
                            item.name = `群${item.to}`
                            item.avatar = item.avatar || this.myGroupIcon
                        }
                    }
                    let lastMsg = item.lastMsg || {}
                    if (lastMsg.type === 'text') {
                        item.lastMsgShow = lastMsg.text || ''
                    } else if (lastMsg.type === 'custom') {
                        let  custom= util.parseCustomMsg(lastMsg);
                        if(custom instanceof Object){
                            item.lastMsgShow='[自定义消息]';
                        }else {
                            item.lastMsgShow = util.parseCustomMsg(lastMsg)
                        }
                    } else if (lastMsg.scene === 'team' && lastMsg.type === 'notification') {
                        item.lastMsgShow = util.generateTeamSysmMsg(lastMsg)
                    } else if (util.mapMsgType(lastMsg)) {
                        item.lastMsgShow = `[${util.mapMsgType(lastMsg)}]`
                    } else {
                        item.lastMsgShow = ''
                    }
                    if (item.updateTime) {
                        item.updateTimeShow = util.formatDate(item.updateTime, true)
                    }
                    return item
                });
                return sessionlist
            },

            //聊天详情页
            robotInfos () {
                return this.$store.state.robotInfos
            },
            msglist () {
                let msgs = this.$store.state.currSessionMsgs
                return msgs
            },
            teamInfo() {
                if (this.scene==='team') {
                    var teamId =  this.sessionId.replace('team-','')
                    return this.$store.state.teamlist.find(team=>{
                        return team.teamId === teamId
                    })
                }
                return undefined
            },
            muteInTeam(){
                if(this.scene!=='team') return false
                var teamMembers = this.$store.state.teamMembers
                var Members = teamMembers && teamMembers[this.teamInfo.teamId]
                var selfInTeam = Members && Members.find(item=>{
                    return item.account === this.$store.state.userUID
                })
                return selfInTeam && selfInTeam.mute || false
            },
            teamInvalid() {
                if (this.scene==='team') {
                    return !(this.teamInfo && this.teamInfo.validToCurrentUser)
                }
                return false
            },
            sendInvalidHint() {
                if (this.scene==='team' && this.teamInvalid) {
                    return `您已不在该${this.teamInfo && this.teamInfo.type==='normal'? '讨论组':'群'}，不能发送消息`
                } else if (this.muteInTeam) {
                    return '您已被禁言'
                }
                return '无权限发送消息'
            }
        },
        methods: {
            enterSysMsgs () {
                if (this.hideDelBtn())
                    return
                location.href = '#/sysmsgs'
            },
            setCurrentShow(userId){
                this.$store.dispatch('showLoading');
                // 此时设置当前会话
                this.$store.dispatch('searchUsers', {
                    accounts: [userId]
                })
                this.sessionId='p2p-'+userId;
                this.$store.dispatch('setCurrSession', this.sessionId)
                pageUtil.scrollChatListDown()

                setTimeout(() => {
                    this.$store.dispatch('hideLoading')
                }, 1000);
                this.isShowChat=true;
            },
            showChat (session) {
                this.$store.dispatch('showLoading')
                // 此时设置当前会话
                this.isShowChat=true;
                this.sessionId=session.id;
                this.$store.dispatch('setCurrSession', this.sessionId)
                pageUtil.scrollChatListDown()

                setTimeout(() => {
                    this.$store.dispatch('hideLoading')
                }, 1000)

                // 获取群成员
                if(this.scene === 'team') {
                    var teamMembers = this.$store.state.teamMembers[this.to]
                    if (teamMembers === undefined || teamMembers.length < this.teamInfo.memberNum) {
                        this.$store.dispatch('getTeamMembers', this.to)
                    }
                }
            },
            enterMyChat () {
                // 我的手机页面
                location.href = `#/chat/p2p-${this.myPhoneId}`
            },
            deleteSession (delSessionId) {
                this.$confirm('是否从会话列表移除此项?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.userInfo={};
                    this.$store.dispatch('logout');
                    this.$router.push({ path: '/' });
                    this.$message({
                        type: 'success',
                        message: '成功退出!'
                    });
                })
                if (this.delSessionId !== null) {
                    this.$store.dispatch('deleteSession', delSessionId)
                }
            },
            showDelBtn (vNode) {
                if (vNode && vNode.data && vNode.data.attrs) {
                    this.delSessionId = vNode.data.attrs.sessionId
                    this.stopBubble = true
                    setTimeout(() => {
                        this.stopBubble = false
                    }, 20)
                }
            },
            hideDelBtn () {
                if (this.delSessionId !== null && !this.stopBubble) {
                    // 用于判断是否前置状态是显示删除按钮
                    this.delSessionId = null
                    return true
                }
                return false
            },
            imOut(){
                this.$store.dispatch('logout');
            },
            //右击事件
            confirmDelSessionId(delSessionId){
                let that=this;
                that.$confirm('是否从会话列表移除此项?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    that.$store.dispatch('deleteSession', delSessionId)
                })
            },


        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/css/common";
    @import "../plugins/NIM/theme.css";
.session{
    @include main-content;
    /*.session-tab{
        overflow: hidden;
        li{
            float: left;
            line-height: 32px;
            width: 33.33%;
            cursor: pointer;
            &.active{
                background-color: $main-color;
                color: #ffffff;
            }
        }
    }*/
    .box-sizing {
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
    }
    .icon {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-image: url(~@/assets/images/nim/icons.png);
        background-repeat: no-repeat;
        vertical-align: middle;
    }
    .icon-team-info {
        background-position: -63px -25px;
    }
    .u-emoji{
        position: relative;
        /*top: 10px;
        left: 8px;*/
        width: 30px;
        height: 30px;
        background: url(~@/assets/images/nim/icons.png) no-repeat center;
        background-position: 2px -187px;
    }
    .radius-circle {
        border-radius: 50%;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
    }
    .title {
        background-color: #e5f4ff;
        line-height: 80px;
        color: #666;
        position: relative;
        border-bottom: 1px solid #ced4d9;
        -webkit-border-radius: 5px 5px 0 0;
        -moz-border-radius:  5px 5px 0 0;
        border-radius:  5px 5px 0 0;
        img {
            width: 56px;
            height: 56px;
            border: none;
            float: left;
            margin: 12px 10px 0 14px;
        }
        .avatar{
            display: inline-block;
            width: 56px;
            height: 56px;
            border: none;
            float: left;
            margin: 12px 10px 0 14px;vertical-align: middle}
        .exit {
            position: absolute;
            right: 12px;
            top: 0;
            line-height: 28px;
            padding-left: 10px;
            border-left: 1px dotted #ccc;
            color: #88939b;
            font-size: 12px;
            cursor: pointer;
        }

    }
    .left-panel {
        width: 260px;
        height: 100%;
        float: left;
        z-index: 99;
        border: 1px solid #424448;
        box-shadow: 0 2px 6px #313131;
        background-color: #fff;
        .list-wrap{
            height: 539px;
            .list {
                height: 100%;
                width: 100%;
                position: relative;
                overflow-y: auto;
                background-color: #fff;
                border-radius: 0 0 5px 5px;
                .m-sysMsg {
                    position: relative;
                    .count {
                        position: absolute;
                        bottom: 20px;
                        right: 9px;
                        background-color: #f24c3d;
                        display: inline-block;
                        font-size: 12px;
                        color: #fff;
                        border-radius: 10px;
                        text-align: center;
                        padding: 0 5px;
                        width: 20px;
                    }
                }
            }
        }

    }
    .right-panel {
        margin-left: 292px;
        height: 620px;
        background-color: #fff;
        position: relative;
        box-shadow: 0 2px 6px #313131;
       /* .chat-box {
            position: relative;
            height: 100%;
            .title{
                background-color: #fff;
                !*.cloudMsg {
                    position: absolute;
                    line-height: 20px;
                    width: 68px;
                    height: 46px;
                    border: 1px solid #ddd;
                    right: 10px;
                    top: 17px;
                    cursor: pointer;
                }*!
            }
        }
        .chat-content {
            position: absolute;
            top: 81px;
            bottom: 60px;
            width: 100%;
            overflow-y: auto;
            padding: 10px 3%;
        }
        .chat-editor {
            position: absolute;
            bottom: 0;
            left: 0;
            height: 60px;
            width: 100%;
            padding: 0 15px;
            background-color: #e5f4ff;
            border-radius: 0 0 5px 5px;
            -webkit-border-radius: 0 0 5px 5px;
            -moz-border-radius: 0 0 5px 5px;
            .chat-btn {
                display: inline-block;
                vertical-align: middle;
                position: relative;
                margin-right: 2px;
                !* vertical-align: top; *!
            }
                .msg-input.p2p {
                !* margin-left: 137px; *!
                width: 500px;
            }
            .msg-input{
                width: 530px;
                height: 38px;
                outline: none;
                background: #fff;
                border: none;
                border: 1px solid #ccc;
                border: 1px solid #ccc\9;
                overflow-y: auto;
                padding: 6px 10px;
                margin-top: 10px;
                resize: none;
                !* vertical-align: -18px!important; *!
                !* margin-left: 65px; *!
            }
            .btn-send {
                background-color: #0888ff;
                color: #fff;
                display: inline-block;
                width: 70px;
                height: 34px;
                line-height: 36px;
                text-align: center;
                position: absolute;
                top: 11px;
                right: 15px;
                font-size: 12px;
                border: 1px solid #0070d9;
            }
        }*/
    }

    .radius5px {
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
}
    .session-list{
        li{
            .tx{
                width:50px;
                height:50px;
                -webkit-border-radius: 50%;
                -moz-border-radius: 50%;
                border-radius: 50%;
                background-color:$main-color;
            }
        }
    }
</style>
